export default "__VITE_ASSET__JwGcYL3f__"